export default __webpack_public_path__ + "static/media/pos-pro-17.9d854568.jpg";